import React from "react";
import { Outlet, NavLink, useNavigate } from "react-router-dom";
import useBranding from "hooks/useBranding";
import useFeatures from "hooks/useFeatures";
import { clearAuthKeepDomainBranding } from "utils/domainBranding";
import payrollnootLogo from "../assets/images/payrollnoot-logo-lg.png";

const NAV_ITEMS = [
    { label: "Companies", path: "/reseller", end: true, icon: "🏢", featureKey: "reseller" },
    { label: "Billing", path: "/reseller/billing", icon: "💳", featureKey: "billing" },
    { label: "Branding", path: "/reseller/branding", icon: "🎨", featureKey: "branding" },
    { label: "Roles & Permissions", path: "/reseller/roles", icon: "🔐", featureKey: "role_permissions" },
];

const ResellerLayout = () => {
    const navigate = useNavigate();
    const branding = useBranding();
    const { hasFeature } = useFeatures();
    const logoSrc = branding.logoUrl || payrollnootLogo;
    const productName = branding.productName || "PayrollNoot";
    const primary = branding.primaryColor || "#1B75F0";
    const userName = localStorage.getItem("userName") || localStorage.getItem("userEmail") || "Reseller";
    const visibleNav = NAV_ITEMS.filter(item => hasFeature(item.featureKey));

    const handleLogout = async () => {
        await clearAuthKeepDomainBranding();
        navigate("/login/reseller");
    };

    return (
        <div style={{ display: "flex", minHeight: "100vh", fontFamily: "Inter, sans-serif" }}>
            <aside style={{
                width: 240,
                background: "#1e293b",
                color: "#fff",
                display: "flex",
                flexDirection: "column",
                flexShrink: 0,
            }}>
                <div style={{ padding: "18px 16px 12px", borderBottom: "1px solid rgba(255,255,255,0.1)" }}>
                    <img
                        src={logoSrc}
                        alt={productName}
                        style={{ height: 44, width: "auto", maxWidth: "100%", objectFit: "contain", display: "block" }}
                    />
                    <div style={{
                        marginTop: 8, fontSize: 10, fontWeight: 700, letterSpacing: 2,
                        textTransform: "uppercase", color: primary,
                    }}>
                        Reseller Portal
                    </div>
                </div>

                <nav style={{ flex: 1, padding: "16px 0", overflowY: "auto" }}>
                    {visibleNav.map(({ label, path, end, icon }) => (
                        <NavLink
                            key={path}
                            to={path}
                            end={!!end}
                            style={({ isActive }) => ({
                                display: "flex",
                                alignItems: "center",
                                gap: 10,
                                padding: "10px 20px",
                                color: isActive ? primary : "rgba(255,255,255,0.85)",
                                background: isActive ? "rgba(27, 117, 240,0.12)" : "transparent",
                                borderLeft: isActive ? `3px solid ${primary}` : "3px solid transparent",
                                textDecoration: "none",
                                fontSize: 14,
                                fontWeight: isActive ? 600 : 400,
                            })}
                        >
                            <span style={{ fontSize: 16 }}>{icon}</span>
                            {label}
                        </NavLink>
                    ))}
                </nav>

                <div style={{ borderTop: "1px solid rgba(255,255,255,0.1)", padding: "14px 20px" }}>
                    <div style={{ fontSize: 12, color: "rgba(255,255,255,0.5)", marginBottom: 6 }}>
                        {userName}
                    </div>
                    <button
                        onClick={handleLogout}
                        style={{
                            background: "rgba(255,255,255,0.08)",
                            border: "none",
                            color: "rgba(255,255,255,0.85)",
                            borderRadius: 6,
                            padding: "8px 12px",
                            width: "100%",
                            cursor: "pointer",
                            fontSize: 13,
                        }}
                    >
                        Sign out
                    </button>
                </div>
            </aside>

            <main style={{ flex: 1, background: "#f8fafc", overflow: "auto" }}>
                <div style={{ padding: "28px 32px", maxWidth: 1100, margin: "0 auto" }}>
                    <Outlet />
                </div>
            </main>
        </div>
    );
};

export default ResellerLayout;
